/**
 * Per-item `animationDelay` (ms) for a staggered "one at a time" reveal —
 * pair with the `.stagger-item` class. Delay is capped past `maxItems` so long
 * lists (table rows, cards) don't take seconds to finish revealing; items
 * beyond the cap all share the same (max) delay.
 */
export default function staggerDelay(index: number, { stepMs = 30, maxItems = 12 }: { stepMs?: number; maxItems?: number } = {}): number {
  return Math.min(index, maxItems) * stepMs;
}
